import { useAppSelector } from '@hooks/reduxHooks';
import { $api } from '@service/RequestService';
import { stringify } from 'query-string';
import { useQuery } from 'react-query';

import { offerModels } from '..';

export function useBuildings(houses?: number[]) {
  const selectHouses = useAppSelector(({ offerReducer: { createOrUpdate } }) => createOrUpdate?.filter?.houses);

  const initial = {
    buildings: []
  };

  const { data = initial, ...arg } = useQuery<{ buildings: offerModels.BuildingType[] }>(
    ['offer-buildings', (houses || selectHouses)?.join()],
    async () => {
      const { data } = await $api.get(
        `/v1/building/compact?${stringify({
          houseId: houses || selectHouses
        })}`
      );

      return { buildings: data?.data };
    },
    {
      enabled: (houses || selectHouses)?.length > 0
    }
  );

  return { ...data, ...arg };
}
